import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import { QUERY_KEYS } from '@/lib/constants';
import type { ApiResponse, DashboardData } from './types';

export function useDashboard() {
  return useQuery({
    queryKey: QUERY_KEYS.dashboard,
    queryFn: () => api.get<ApiResponse<DashboardData>>('/api/v1/dashboard'),
    select: (res) => res.data,
    refetchInterval: 30_000,
  });
}
